//  import React from 'react'
import styled from '@emotion/styled'

import tokens from '../../design/tokens'
import colorNames from '../../design/color-names'

import { THUMBCONTAINER_VARIANT_SMALL } from './constants'

export const StyledThumbContainer = styled.div`
  border: 1px solid ${colorNames.geyser};
  ${({ $variant }) =>
    `border-radius: ${
      $variant === THUMBCONTAINER_VARIANT_SMALL
        ? tokens.borderRadius.xsmall
        : tokens.borderRadius.medium
    };`}
  
  background-color: ${colorNames.pureWhite};
  overflow: hidden;
`

export const StyledThumbContainerHeader = styled.div`
  border-bottom: 1px solid ${colorNames.geyser};
`

export const StyledThumbContainerFooter = styled.div`
  border-top: 1px solid ${colorNames.geyser};
`
